import { render, staticRenderFns } from "./ContentSettingsEditModal.vue?vue&type=template&id=f4745e30&scoped=true&"
import script from "./ContentSettingsEditModal.vue?vue&type=script&lang=js&"
export * from "./ContentSettingsEditModal.vue?vue&type=script&lang=js&"
import style0 from "./ContentSettingsEditModal.vue?vue&type=style&index=0&id=f4745e30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4745e30",
  null
  
)

export default component.exports